// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3280) return "static/chunks/3280-275fffd5b2930c68.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8550 ? "ed48eaa7" : chunkId) + "." + {"2401":"f9c722abc066c166","5528":"1cfa2a63c2dad601","7332":"3b64a9b7ae15571d","7459":"34b2d3ba57c1b643","7513":"15be4b214498e438","7771":"f7efd84eb4f4bac6","8063":"2073fdf03b959e74","8550":"721b77290155aec1","8835":"cd8680a3a4482084"}[chunkId] + ".js";
};